import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("epas_token");
    const email = localStorage.getItem("epas_email");
    if (token && email) {
      setUser({ email });
    }
    setBooted(true);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("epas_token", data.token);
    localStorage.setItem("epas_email", data.email);
    setUser({ email: data.email });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("epas_token");
    localStorage.removeItem("epas_email");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, booted }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
